export default __webpack_public_path__ + "static/media/pic4.1e8ccf99.jpg";